// Bridge so the axios interceptor (outside React) can push toasts.
let pushFn = (msg, kind) => { /* noop until ToastProvider wires up */ };
export function setToastPusher(fn) { pushFn = fn || (() => {}); }
export function toast(msg, kind = "error") { pushFn(msg, kind); }
